import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useApiQuery } from '@/utils/use-api-query'
import { $t } from 'packages/locale'
import { FC, useContext } from 'react'

import { IndexBoardCard } from '../components/IndexBoardCard'
import { DataBoardContext } from '../context'
import { useStatsApiQuery } from '../utils/query'
import { getDeviceCardTips } from '../utils/tips'

/**
 * 外卖违规统计卡片
 *
 * @returns TakeoutViolationCard component
 */
export const TakeoutViolationCard: FC = () => {
  const { semesterInfo, timeRange, role } = useContext(DataBoardContext)
  const reflection = useCurrentReflection()

  const apiQuery = useStatsApiQuery({
    timeRange,
    semesterInfo,
  })

  const { data: res, loading } = useApiQuery({
    apiName: 'queryAdvisorStudentTakeoutAssessmentStats',
    params: {
      query: apiQuery,
    },
    options: {
      enabled: !!reflection?.usin,
    },
  })

  const { data: takeoutStats } = res || {}
  const getInfo = (type: 'self' | 'trust' | 'help') =>
    takeoutStats?.find((item) => item.type === type)
  const selfCount = getInfo('self')?.type_user_count ?? 0
  const trustCount = getInfo('trust')?.type_user_count ?? 0
  const helpCount = getInfo('help')?.type_user_count ?? 0

  return (
    <IndexBoardCard
      title={$t('外卖违规统计')}
      count={takeoutStats?.at(0)?.total_user_count ?? 0}
      items={[
        {
          label: $t('自行点购'),
          value: selfCount ?? 0,
        },
        {
          label: $t('委托代购'),
          value: trustCount ?? 0,
        },
        {
          label: $t('协助递送'),
          value: helpCount ?? 0,
        },
      ]}
      flex={2}
      type={StatsDetailsTabEnum.StudentTakeoutViolation}
      loading={loading}
      tips={getDeviceCardTips(role)}
      itemIconMsg={{
        name: 'CallBell',
        color: '#F5651D',
        backgroundColor: '#FFF4E8',
      }}
    />
  )
}
